import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useTutorKanbanStore } from './store'

interface MainInfoEmailReturn {
  refValue: ComputedRef<string>
}

export const useMainInfoEmail = (): MainInfoEmailReturn => {
  const tutorKanbanStore = useTutorKanbanStore()

  const refValue = computed<string>(() => tutorKanbanStore.getTutor?.email ?? '')

  return {
    refValue,
  }
}
